<div class="common-navbar">
  <div class="common-btn-back" *ngIf="back">
    <button mat-icon-button class="btn" (click)="goBack()">
      <mat-icon class="icon">keyboard_arrow_left</mat-icon>
    </button>
  </div>
  <div class="common-title">{{title}}</div>
  <div class="common-btn-setting" *ngIf="setting">
    <button mat-icon-button class="btn" (click)="goSetting()">
      <mat-icon class="icon">menu</mat-icon>
    </button>
    <div class="navbar-new-icon" *ngIf="notice.hasNew()">N</div>
  </div>
</div>
